import { render, staticRenderFns } from "./WebIntegrationEditor.vue?vue&type=template&id=61fa72d8&scoped=true"
import script from "./WebIntegrationEditor.vue?vue&type=script&lang=js"
export * from "./WebIntegrationEditor.vue?vue&type=script&lang=js"
import style0 from "./WebIntegrationEditor.vue?vue&type=style&index=0&id=61fa72d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fa72d8",
  null
  
)

export default component.exports